/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

const createMarkup = label => {
  return {
    __html: label,
  };
};

const CheckBox = ({
  value,
  tick,
  onCheck,
  label,
  classname,
  testValue,
  onBlur,
  onFocus,
}) => {
  return (
    <div
      className={classname}
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex="-1"
      style={{ outlineStyle: 'none' }}
    >
      <input
        type="checkbox"
        value={value}
        checked={tick}
        onChange={onCheck}
        id={value}
      />
      <label htmlFor={value} data-test={testValue} >
        { /* <span style={{ paddingLeft: '5px' }}>{label}</span> */ }
        <span
          style={{ paddingLeft: '5px' }}
          dangerouslySetInnerHTML={createMarkup(label)}
        />
      </label>
    </div>
  );
};

CheckBox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tick: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onCheck: PropTypes.func,
  label: PropTypes.string,
  classname: PropTypes.string,
  testValue: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default CheckBox;
